<template>
	<div :class="options.wrapperClass">
		<div :class="options.className"></div>
	</div>
</template>

<script>
import shared from '@/mixins/shared';

export default {
	mixins: [shared],
};
</script>
